import { render, staticRenderFns } from "./TeamsTab.vue?vue&type=template&id=8a2ff592&scoped=true&"
import script from "./TeamsTab.vue?vue&type=script&lang=js&"
export * from "./TeamsTab.vue?vue&type=script&lang=js&"
import style0 from "./TeamsTab.vue?vue&type=style&index=0&id=8a2ff592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2ff592",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QBtn,QInput,QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QBtn,QInput,QSelect})
